import withStyles from "@material-ui/core/styles/withStyles";
import { IStore, AppDispatch } from "../store";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { DriverStateDTO, Race } from "../api/model";
import { Theme, WithStyles, Paper, Grid, Typography, CircularProgress } from "@material-ui/core";
import { mockTheme, WithActions, toMap } from "../utils/utils";
import { RaceActions } from "../store/race/race-actions";
import { connect } from "react-redux";
import StoreModel, { LoadedSingleResource } from "../store/StoreModel";
import RaceDataComponent from "../components/race/RaceDataComponent";
import RaceTrace from "../components/race/RaceTrace";
import { bindActionCreators } from "redux";
import { DriverActions } from "../store/driver";
import { ConfigData } from "../config";
import RaceMiscActions from "src/components/race/RaceMiscActions";
import { Link } from "react-router-dom";
import { SortDirection } from "@material-ui/core/TableCell";
import AsyncTable, { ColumnDefinition } from "src/components/AsyncTable";
import { getApi } from "src/api/ApiProvider";
import RaceExtraDetail from "src/components/race/RaceExtraDetail";
import { IUser } from "src/utils/userHandler";

const styles = (theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
});

const classesType = styles(mockTheme);

interface RacePageProps
  extends RouteComponentProps<{ id: string }>,
  WithStyles<keyof typeof classesType>,
  WithActions<RaceActions> {
  driverActions: DriverActions;
  config: ConfigData;
  race: LoadedSingleResource<Race>;
  driverLocations: { [k: string]: LoadedSingleResource<DriverStateDTO> };
  auth: IUser;
}
interface RacePageState {
  notificationData: any[];
  tableNotification: {
    data: any,
    sortBy: string,
    sortDirection: SortDirection
    columnData: ColumnDefinition[],
  }
  images?: string[],
  isLoading?: boolean;
}

class RacePage extends React.Component<RacePageProps, RacePageState> {
  trace?: NodeJS.Timer;

  constructor(props: RacePageProps) {
    super(props);
    console.log('props', props)
    this.state = {
      notificationData: [],
      tableNotification: {
        data: [],
        sortBy: 'name',
        sortDirection: 'desc',
        columnData: [
          { path: 'message', numeric: false, label: 'Mensaje' },
          {
            path: 'type', numeric: false, label: 'Tipo',
            draw: (row: any, val) => {
              return (
                <div>
                  {val.type === 'RACE' ? 'Carrera' : 'Otro'}
                </div>
              );
            }
          },
          { path: 'notificacionDate', numeric: false, label: 'Fecha' },
        ]
      },
      images: undefined,
      isLoading: false,
    }
    this.handleClickNotification(Number(this.props.match.params.id))
  }

  handleClickNotification(id: number) {
    getApi().history().notificationHistoryRaces(id).then(
      (data: any[]) => {
        this.setState({ notificationData: data });
      }).catch(err => {
        console.log('err', err)
      })

  }

  componentDidMount() {
    this.props.actions.fetchWithDriverInfo(this.props.match.params.id, false);
    this.trace = setInterval(() => {
      this.props.actions.fetchWithDriverInfo(this.props.match.params.id, true);
    }, 1000 * 10);

    // Espera a que la carrera esté cargada y luego obtiene las imágenes
    setTimeout(() => {
      const race = this.props.race.data;
      if (race && race.files && race.files.length > 0) {
        this.fetchImagenes(race.id, race.files);
      }
    }, 1000);
  }

  componentWillUnmount() {
    if (this.trace) {
      clearInterval(this.trace);
    }
  }
  getImage = async (raceId: number, idFile: number) => {
    try {
      const resp = getApi().race().getFiles(raceId, idFile)
      return resp;
    } catch (error) {
      console.error('Error al obtener la imagen:', error);
      return null;
    }
  }
  blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        // El resultado es data:[mime];base64,xxxxxx
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  fetchImagenes = async (raceId: number, files: any) => {
    this.setState({ isLoading: true });
    try {
      if (files && files.length > 0) {
        const images: string[] = [];
        for (const file of files) {
          const blob = await this.getImage(raceId, file.id);
          if (blob instanceof Blob) {
            const base64 = await this.blobToBase64(blob);
            images.push(base64);
          }
        }
        this.setState({ images, isLoading: false });
      }
      console.log('Imágenes obtenidas:', this.state.images);
    } catch (error) {
      console.error('Error al obtener la imagen:', error);
      // Alert.alert('Error al obtener la imagen');
      this.setState({ isLoading: false });
    } finally {
      // setIsLoading(false);
    }
  }

  /**
   * Este componente no debería re renderizarse una vez que ya
   * se haya cargado al menos una vez la carrera.
   *
   * @param nextProps the next props
   */
  // shouldComponentUpdate(nextProps: RacePageProps) {
  //   if (nextProps.match.params.id === this.props.match.params.id) {
  //     if (
  //       StoreModel.isLoaded(nextProps.race) &&
  //       StoreModel.isLoaded(this.props.race)
  //     ) {
  //       return false;
  //     }
  //   }
  //   return true;
  // }
  shouldComponentUpdate(nextProps: RacePageProps, nextState: RacePageState) {
  // Solo evita el render si props y estado relevantes no han cambiado
  return (
    nextProps.match.params.id !== this.props.match.params.id ||
    nextProps.race !== this.props.race ||
    nextState.images !== this.state.images ||
    nextState.isLoading !== this.state.isLoading
  );
}

  renderRace(race: Race) {

    const driver = race.driver;
    // const { driver } = StoreModel.isLoaded(this.props.driverLocations[race.data!.driver.id])
    return (
      <Grid container spacing={16}>
        <Grid item sm={12} md={6} /*lg={6}*/>
          <Paper elevation={5} style={{ padding: 10 }}>
            <Link to="/">Ir al Listado de carreras</Link>
            <RaceTrace
              raceId={race.id}
              driverId={driver ? driver.id : null}
              config={this.props.config}
            />
          </Paper>
          {race.type === 'SEND_PACKET' && race.state === 'DELIVERED' ? (
            this.state.isLoading ? (
              <div style={{ textAlign: "center", margin: "20px 0" }}>
                <CircularProgress />
                <Typography>Cargando imágenes...</Typography>
              </div>
            ) : (
              this.state.images && this.state.images.length > 0 ? (
                <RaceExtraDetail race={race} images={this.state.images} />
              ) : (
                <Typography>No hay imágenes disponibles.</Typography>
              )
            )
          ) : null}
          <Paper elevation={5} style={{ padding: 10 }}>
            <Typography variant="title">Notificaciones</Typography>
            <AsyncTable
              columnDefinition={this.state.tableNotification.columnData}
              title=''
              showHeader={false}
              data={this.state.notificationData}
              defaultOrder={{
                name: 'time',
                direction: 'desc'
              }}
            />
          </Paper>
        </Grid>
        <Grid item sm={12} md={6} /*lg={6}*/>
          <Paper elevation={5} style={{ padding: 10 }}>
            <RaceMiscActions race={race} user={this.props.auth} />
            <RaceDataComponent race={race} />
          </Paper>
        </Grid>
      </Grid>
    );
  }

  render() {
    const { classes, race } = this.props;

    if (StoreModel.isLoading(race)) {
      return <div>Cargando...</div>;
    }
    if (StoreModel.isError(race)) {
      return (
        <Grid container className={classes.root} spacing={16}>
          <Grid item xs={12}>
            <Paper elevation={11} style={{ padding: 40, textAlign: "center" }}>
              <Typography variant="display2" style={{ paddingBottom: 20 }}>
                :(
              </Typography>
              <Typography variant="title">
                La carrera que buscas no se ha podido cargar
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      );
    }

    return this.renderRace(race.data!);
  }
}

const mapStateToProps = (state: IStore, ownProps: RacePageProps) => ({
  ...ownProps,
  race: state.race.byId[ownProps.match.params.id],
  driver: state.driver.locationById,
  config: state.config.data,
  auth : state.auth.user,
});

const styled = withStyles(styles as any)(RacePage);
// const connected = connect(mapStateToProps, bindActions(RaceActions))(styled as any);
const connected = connect(mapStateToProps, (dispatch: AppDispatch) => {
  return {
    actions: bindActionCreators(toMap(RaceActions), dispatch),
    driverActions: bindActionCreators(toMap(DriverActions), dispatch),
  };
})(styled);

export default connected as React.ComponentClass<Partial<RacePageProps>>;



// WEBPACK FOOTER //
// ./src/pages/RacePage.tsx